import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { GoldoniAccountData } from '../_models/goldoni/GoldoniAccountData';
import { environment } from '../../../environments/environment';

@Injectable()
export class GoldoniService {
  private apiBaseUrl = environment.apiBaseUrl;

  constructor(private http: HttpClient) {}

  getGoldoniAccountData(): Observable<GoldoniAccountData> {
    return this.http
      .get<any>(this.apiBaseUrl + 'api/private/v1/goldoni/getGoldoniAccountData')
      .pipe(map((response) => response));
  }

  storeGoldoniCredentials(goldoniAccountData: GoldoniAccountData) {
    return this.http
      .post(this.apiBaseUrl + 'api/private/v1/goldoni/storeGoldoniCredentials', goldoniAccountData)
      .pipe(map((response) => response));
  }
}
